import permissions from '@/constants/permissions'

const CoordinatorQuestionnaire = () => import('@/views/document/CoordinatorQuestionnaire.vue')
export default {
  path: 'ankieta-koordynatora',
  name: 'CoordinatorQuestionnaire',
  component: CoordinatorQuestionnaire,
  meta: {
    requireAuth: true,
    permission: [
      permissions.coordinatorQuestionnaireAdditionalView,
      permissions.coordinatorQuestionnaireAdd,
      permissions.documentView,
      permissions.assignedDocumentView
    ]
  }
}
